interface State {
    urls: string[];
}

const initialState: State = {
    urls: [],
};

export const UPDATE_VIDEO = 'UPDATE_VIDEO' as 'UPDATE_VIDEO';
export const updateVideo = (youtubeUrl?: string) => ({
    type: UPDATE_VIDEO,
    payload: youtubeUrl,
});

type Action = ReturnType<typeof updateVideo>;

export default (state = initialState, action: Action): State => {
    switch (action.type) {
        case UPDATE_VIDEO: {
            return { urls: action.payload ? [action.payload] : [] };
        }
        default: return state;
    }
};
